<template>
  <li
    :class="`transport-systems-item ${system.code}`"
    @click="clickHandler(system)"
    v-loading="system.id === loadingItem"
  >
    <div class="transport-systems-item__icon">
      <r-icon :name="icons[system.code]" :size="18" />
    </div>
    <div class="transport-systems-item__info">
      <r-text>{{ system.category }} ({{ system.code }})</r-text>
      <r-text type="caption">
        {{ system.name }}
      </r-text>
    </div>
    <div class="transport-systems-item__actions">
      <slot>
        <el-switch class="r-switch" :value="system.enabled" />
      </slot>
    </div>
  </li>
</template>

<script>
const icons = {
  C: "road-accident",
  G1: "bulldozer-2",
  G2: "bulldozer-2",
  G3: "bulldozer-2",
  B1: "bus",
  B2: "bus",
  B3: "bus",
  T1: "trolleybus",
  T2: "tram"
};

export default {
  props: ["system", "loading-item"],
  data() {
    return {
      icons
    };
  },
  methods: {
    clickHandler(system) {
      this.$emit("click", system);
    }
  }
};
</script>

<style lang="scss">
.transport-systems-item {
  display: flex;
  align-items: center;
  border-radius: var(--border-radius);
  background-color: var(--modal_bg) !important;
  padding: 2px 12px;
  cursor: pointer;

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  &:hover {
    &.C {
      background: rgba(85, 183, 126, 0.2) !important;
    }
    &.G1,
    &.G2,
    &.G3 {
      background: rgba(145, 94, 255, 0.2) !important;
    }
    &.B1,
    &.B2,
    &.B3 {
      background: rgba(255, 76, 141, 0.2) !important;
    }
    &.T1 {
      background: rgba(248, 195, 72, 0.2) !important;
    }
    &.T2 {
      background: rgba(229, 101, 102, 0.2) !important;
    }
  }

  &__icon {
    margin-right: 12px;
  }

  &__actions {
    margin-left: auto;
  }
}
</style>
